export const RouteName = {
  DEFAULT: '/',
  SIGN_IN: '/login',
  PASSWORD_RESET: '/password-reset',
  PASSWORD_RESET_CONFIRM: '/password-reset-confirm',
  REGISTER: '/register',
  ENVELOPE: '/envelope',
  ENVELOPES: '/envelopes',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  USERS: '/users',
  INVITES: '/invites',
};

export const PathServiceName = {
  PARENT: '/:parent',
  ID: '/:id',
  TYPE: '/:type',
  ASTERISK_SYMBOL: '/*',
  ADD: '/add',
  EDIT: '/edit',
};

export const Section = {
  ENVELOPES_BOX_OGUID: `${RouteName.ENVELOPES}/:boxOguid`,
  ENVELOPES_FILTER: `${RouteName.ENVELOPES}/filters`,
  ENVELOPES_BOX_SETTINGS: `${RouteName.ENVELOPES}/:boxOguid${RouteName.SETTINGS}`,
};

export const Path = {
  ENVELOPE: `${RouteName.ENVELOPE}/:oguid`,
  ENVELOPE_BUSINESS: `${Section.ENVELOPES_BOX_OGUID}/envelope/:oguid`,
  ENVELOPES_FAST_ACCESS: `${RouteName.ENVELOPES}/:directionParam`,
  ENVELOPES_BOX_OGUID: `${Section.ENVELOPES_BOX_OGUID}/:directionOrFolder`,
  ENVELOPES_BOX_SETTINGS: `${Section.ENVELOPES_BOX_OGUID}${RouteName.SETTINGS}/general`,
  ENVELOPES_BOX_USERS: `${Section.ENVELOPES_BOX_OGUID}${RouteName.SETTINGS}${RouteName.USERS}`,
  ENVELOPES_BOX_INVITES: `${Section.ENVELOPES_BOX_OGUID}${RouteName.SETTINGS}${RouteName.USERS}${RouteName.INVITES}`,
  ENVELOPES_ALL: `${RouteName.ENVELOPES}/all`,
  ENVELOPE_NEW: `${RouteName.ENVELOPE}/new`,
  ENVELOPES_FILTER: `${Section.ENVELOPES_FILTER}/:oguid`,
  REGISTER: RouteName.REGISTER,
  PASSWORD_RESET: RouteName.PASSWORD_RESET,
  PASSWORD_RESET_CONFIRM: RouteName.PASSWORD_RESET_CONFIRM,
  SIGN_IN: RouteName.SIGN_IN,
};
